import { Entity, IField } from "@/app/fields/types";
import { useIsForm } from "@/app/hooks/useIsForm";
import { batchArray } from "@/app/utils/batchArray";
import { groupByFormSection } from "@/app/utils/groupByFormSection";
import { PageHeader } from "@saas-ui-pro/react";
import { FormLayout } from "@saas-ui/react";
import React from "react";

const NUMBER_OF_COLUMNS = 3;

export default function DetailPageLayout<T extends Entity>({
  fields,
  render,
}: {
  fields: IField<T>[];
  render: (field: IField<T>) => React.ReactNode;
}) {
  const isForm = useIsForm<T>();
  return (
    <FormLayout gap={8} pb={12}>
      {Object.entries(groupByFormSection(fields.filter((f) => isForm(f)))).map(
        ([sectionKey, sectionFields]) => (
          <FormLayout
            key={sectionKey}
            data-cy={`form-section-${sectionKey}`}
            gap={8}
          >
            <PageHeader title={sectionKey.toUpperCase().replace("_", " ")} />
            {batchArray(sectionFields, NUMBER_OF_COLUMNS).map((row, index) => (
              <FormLayout key={index} columns={NUMBER_OF_COLUMNS} gap={12}>
                {row.map((field) => (
                  <div key={String(field.field)} className="mb-4">
                    {render(field)}
                  </div>
                ))}
              </FormLayout>
            ))}
          </FormLayout>
        )
      )}
    </FormLayout>
  );
}
